import { constants } from '@/constants';
import type { FlowType, SessionSource } from '@/store/SessionStore';
import cookieManager from '../cookieHelper';

export const getClubCode = () => {
  const zipCookie = cookieManager('zipcode');
  if (zipCookie !== null) {
    const clubcode = zipCookie.split('|')[2];
    return clubcode ? clubcode.padStart(3, '0') : '';
  }
  return '';
};

export const getZipCode = () => {
  const zipCookie = cookieManager('zipcode');
  if (zipCookie !== null) {
    const zip = zipCookie.split('|')[0];
    return zip;
  }
  return '';
};

export const deriveFlowTag = (
  sessionSource: SessionSource,
  flowType: FlowType,
): string => {
  if (sessionSource === 'new' && flowType === 'emailInquiry') {
    return 'advisor inquiry';
  }

  if (sessionSource === 'email') {
    return flowType ? `email:${flowType}` : 'email';
  }

  let tag = 'new';

  if (flowType) {
    tag += `:${flowType}`;
  }

  return tag;
};

export const formatExperimentFlags = (
  flags: Record<string, boolean> | null | undefined,
): string => {
  if (!flags || Object.keys(flags).length === 0) {
    return '';
  }

  return Object.entries(flags)
    .map(([flagName, value]) => `${flagName}:${value}`)
    .join(',');
};

export const loadUtagJs = () => {
  if (window.utagLoadAttempt) return;
  window.utagLoadAttempt = true;
  const utagJsScript = document.createElement('script');
  utagJsScript.src = constants.UTAG_SCRIPT_SRC;
  utagJsScript.type = 'text/javascript';
  utagJsScript.async = true;
  document.body.appendChild(utagJsScript);
};
